import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsString,
  IsInt,
  IsEnum,
  MaxLength,
  Min,
  Matches,
  IsArray,
  IsOptional,
} from 'class-validator'
import { Track } from '../../../enums/track.enum'

/**
 * DTO for creating a new level
 */
export class CreateLevelDto {
  @ApiProperty({
    description: 'Unique code for the level (e.g., 6EME, 2NDE)',
    example: '6EME',
    maxLength: 64,
  })
  @IsString()
  @MaxLength(64)
  @Matches(/^[A-Z0-9_]+$/, {
    message:
      'Code must contain only uppercase letters, numbers, and underscores',
  })
  code!: string

  @ApiProperty({
    description: 'Display label for the level',
    example: 'Sixième',
    maxLength: 255,
  })
  @IsString()
  @MaxLength(255)
  label!: string

  @ApiPropertyOptional({
    description: 'Detailed description of the level',
    example: 'Middle school 6th grade',
  })
  @IsOptional()
  @IsString()
  description?: string

  @ApiProperty({
    description: 'Numeric order for sorting levels',
    example: 10,
    minimum: 0,
  })
  @IsInt()
  @Min(0)
  order!: number

  @ApiProperty({
    description: 'Educational tracks (array)',
    enum: Track,
    isArray: true,
    example: [Track.COLLEGE],
  })
  @IsArray()
  @IsEnum(Track, { each: true })
  track!: Track[]
}
